module.exports = __webpack_public_path__ + "static/media/icon3.39f4f6d6.svg";